var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';
/**
 * Request body for placing a Mahnsperre (dunning block) on an invoice
 * (PRD #988). `reason` is required free-text (no enum in v1); `blockedUntil`
 * is an optional ISO date — omitted/null ⇒ blocked until manually lifted, a
 * date ⇒ temporary block that auto-expires.
 */
export class SetDunningBlockDto {
    reason;
    blockedUntil;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    MaxLength(512),
    __metadata("design:type", String)
], SetDunningBlockDto.prototype, "reason", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", Object)
], SetDunningBlockDto.prototype, "blockedUntil", void 0);
//# sourceMappingURL=set-dunning-block.dto.js.map